/*  
 *  Archivo destinado a manejar todas las funciones responsables de comunicación con 
 *  el servidor, referentes al usuario.
 */

import fetchData from "./utils/fetchData";

const url = process.env.REACT_APP_SERVER_URL + '/productos';

export const getProductos = async (currentUser, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> getProductos');
    //console.log(currentUser);

    let body = null;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/getAllRows`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        dispatch({ type: 'UPDATE_PRODUCTOS', payload: result });
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}




export const borrarProducto = async (datos, currentUser, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> BorrarProducto');
    //console.log(currentUser);

    let body = datos;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/deleteRow`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

export const EnviarNuevoProducto = async (datos, currentUser, dispatch) => {
    //la variable "datos" contiene: { id, codigoBarras, nombreProducto, descripcion, marcaState, categoriaState, habilitado }
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> NuevaMarca');
    //console.log(currentUser);

    let body = datos;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/addRow`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

export const actualizarProducto = async (datos, currentUser, dispatch) => {
    //la variable "datos" contiene: { id, codigoBarras, nombreProducto, descripcion, marcaState, categoriaState, habilitado }
    //NOTA. A pesar que se envían todos los campos de producto, sólo se actualiza: nombre, descripcion, categoria y habilitado
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> NuevaMarca');
    //console.log(currentUser);

    let body = datos;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/updateRow`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}


